export const GET_STATS = {
  BEGIN: 'GET_STATS_BEGIN',
  SUCCESS: 'GET_STATS_SUCCESS',
  FAILURE: 'GET_STATS_FAILURE'
}
